import { Environment } from "../../../environment";
import { IMessage } from "../../../types/message";
import { Api } from "../axios-config";
import { IDetalheCliente } from "../client/clientService";
import { IDetalheContract } from "../contract/contractService";

export interface IListagemClientContract {
  id: string;
  createdAt: string;
  updatedAt?: string;
  signed_dateAt?: string;
  uploadedAt?: string;
  signersCopies?: string;
  clientIdAdmin?: string;
  clientId?: string;
  contractId?: string;
  statusSignature: string;
  clientId_admin?: IDetalheCliente;
  client_id?: IDetalheCliente;
  contract?: IDetalheContract;
}

export interface IDetalheClientContract {
  id: string;
  createdAt: string;
  updatedAt?: string;
  signed_dateAt?: string;
  uploadedAt?: string;
  signersCopies?: string;
  clientIdAdmin?: string;
  clientId?: string;
  contractId?: string;
  statusSignature: string;
  clientId_admin?: IDetalheCliente;
  client_id?: IDetalheCliente;
  contract?: IDetalheContract;
}

export interface IListagemClientContractByContract {
  client_contract_id: string;
  client_contract_title: string;
  client_contract_created_at: string;
  client_contract_updated_at: string;
  client_contract_signed_date_at: string | null;
  client_contract_uploaded_at: string | null;
  client_contract_signers_copies: string | null;
  client_contract_clientId_admin: string;
  client_contract_clientId: string;
  client_contract_contractId: string;
  client_contract_doc_key: string | null;
  client_contract_storage: number;
  client_contract_status_signature: string;
  client_name: string;
  client_document: string;

  // campos duplicados (alguns retornos trazem sem o prefixo client_contract_)
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
  signed_date_at: string | null;
  uploaded_at: string | null;
  signers_copies: string | null;
  clientId_admin: string;
  clientId: string;
  contractId: string;
  doc_key: string | null;
  storage: number;
  status_signature: string;

}

type TClientContractTotalCount = {
  results: IListagemClientContract[];
  total: number;
};

type TClientContractByContractTotalCount = {
	results: IListagemClientContractByContract[];
	total: number;
};

export type TClientContractByContractPromise = TClientContractByContractTotalCount | Error;

export type TClientContractPromise = string | Error | undefined;

export type TClientContractAllPromise = TClientContractTotalCount | Error;

const getAll = async (
  page: number = 1,
  title: string = "",
  status: string = "",
  statusClient: string = ""
): Promise<TClientContractAllPromise> => {
  try {
    const urlRelativa = `/client-contract?_page=${page}&_limit=${Environment.LIMITE_LINHAS}&title=${title}&status=${status}&statusClient=${statusClient}`;

    const { data } = await Api().get(urlRelativa);

    if (data.results) return data;

    return new Promise((_, reject) =>
      reject(new Error("Erro ao listar registros."))
    );
  } catch (error: any) {
    console.error(error);
    throw new Promise((_, reject) => reject(error));
  }
};

const getAllByContractId = async (
  contractId: string,
  page: number = 1,
  rowsPerPage: number = 10,
  status: string = "todos"
): Promise<TClientContractByContractPromise> => {
  try {
    const urlRelativa = `/client-contract/por-contrato?_page=${page}&_limit=${rowsPerPage}&contractId=${contractId}&status=${status}`;
    const { data } = await Api().get(urlRelativa);

    // alguns endpoints retornam {results,total}; outros podem retornar array
    if (data?.results) return data;
    if (Array.isArray(data)) {
      return { results: data, total: data.length };
    }

    return new Promise((_, reject) => reject(new Error("Erro ao listar detalhes do contrato.")));
  } catch (error: any) {
    console.error(error);
    throw new Promise((_, reject) => reject(error));
  }
};

const shootQueue = async (id: string): Promise<IMessage<null> | Error> => {
  try {
    await Api().post("/client-contract/queue", { id });

    return new Promise((resolve) =>
      resolve({
        message: "Sucesso!",
        description: "Disparo para a fila realizado com sucesso!",
      })
    );
  } catch (error: any) {
    console.error(error);
    return new Promise((_, reject) => reject(error));
  }
};

const getByID = async (id: string): Promise<IDetalheClientContract | Error> => {
  try {
    const { data } = await Api().get(`/client-contract/${id}`);
    if (data) return data;

    return new Promise((_, reject) =>
      reject(new Error("Erro ao listar registro."))
    );
  } catch (error: any) {
    console.error(error);
    return new Promise((_, reject) => reject(error));
  }
};

const updateById = async (
  id: string,
  dados: IDetalheClientContract
): Promise<void | Error> => {
  try {
    await Api().patch(`/client-contract/${id}`, dados);
  } catch (error: any) {
    console.error(error);
    return new Promise((_, reject) => reject(error));
  }
};

export const clientContractService = {
  getAll,
	getAllByContractId,
  getByID,
  updateById,
  shootQueue,
};
